import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {TreoMockApi} from '@treo/lib/mock-api/mock-api.interfaces';
import {TreoMockApiService} from '@treo/lib/mock-api/mock-api.service';
import {analytics as analyticsData} from 'app/data/mock/dashboards/analytics/data';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsMockApi implements TreoMockApi {
  // Private
  private _analytics: any;

  /**
   * Constructor
   *
   * @param _treoMockApiService
   */
  constructor(private _treoMockApiService: TreoMockApiService) {
    // Set the data
    this._analytics = analyticsData;

    // Register the API endpoints
    this.register();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register
   */
  register(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Sales - GET
    // -----------------------------------------------------------------------------------------------------
    this._treoMockApiService.onGet('api/dashboards/analytics').reply(() => {
      return [200, _.cloneDeep(this._analytics)];
    });
  }
}
